// tanstack
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/dashboard',
)({
  beforeLoad: ({ params }) =>
    redirect({
      to: '/$accountId/energyxplorer/portfolio/dashboard',
      params,
      replace: true,
    }),
  staticData: { crumb: 'glossary:dashboard', hideEnergyAnalysisAppBar: true },
});
